import { func } from 'prop-types'

function CodeScanner(props) {
  const styleOfScanner = {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '60%',
    background: '#000',
    zIndex: 2000,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  }
  const styleOfButton = {
    position: 'absolute',
    top: '20px',
    left: '20px',
    color: 'white',
    fontSize: '24px',
    zIndex: 2001,
    cursor: 'pointer',
    background: 'rgba(0,0,0,0.5)',
    width: '40px',
    height: '40px',
    borderRadius: '50%',
    textAlign: 'center',
    lineHeight: '40px',
  }
  return (
    <div style={styleOfScanner}>
      <button
        type="button"
        style={styleOfButton}
        onClick={() => props.closeScanner()}
      >
        X
      </button>
      <div id="html5qr-code-full-region" />
    </div>
  )
}
CodeScanner.propTypes = {
  closeScanner: func.isRequired,
}

export default CodeScanner
